<template>
  <div>
    <form id="myForm">
      <h3 style="font-weight: 500;color:#757575;">Fazer upload de novo arquivo</h3>
      <div :class="!uploading ? 'dropbox' : 'dropuploading'">
        <input
          ref="fileInput"
          id="inputfile"
          v-if="!uploading"
          class="input-file"
          type="file"
          @change="onFileChange"
        />

        <p v-if="!uploading">Arraste e solte seu arquivo aqui.</p>

        <div class="upandamento" v-else>
          <p style="text-align: left;font-size: 1.0rem" v-if="progress != 100">
            Arquivo: {{filename.name}}
            <br />
            Tamanho: {{filename.size}}
          </p>
          <p style="text-align: left;font-size: 1.0rem" v-else>Processando..</p>
          <v-progress-circular
            :rotate="360"
            :size="100"
            :width="15"
            :value="progress.toFixed(2)"
            color="#fff"
          >{{ progress.toFixed(2) + '%' }}</v-progress-circular>
        </div>
      </div>
    </form>
    <md-snackbar :md-duration="5000" md-persistent :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>

<script>
import * as Arquivos from "../../providers/arquivos.service";
export default {
  name: "UploadArquivos",
  sockets: {
    connect() {
      console.log("socket connected");
    },
    upload(data) {
      this.progress = (data.received / data.expected) * 100;
    }
  },
  data() {
    return {
      progress: 0,
      filename: "",
      uploading: false,
      msg: false,
      socketsA: false
    };
  },

  methods: {
    promptPromise(message) {
      return new Promise(function(resolve, reject) {
        var result = window.prompt(message);
        if (result != null) {
          resolve(result);
        } else {
          reject(new Error("User cancelled"));
        }
      });
    },
    onFileChange(e) {
      var self = this;

      self
        .promptPromise("Entre com a versão do arquivo:")
        .then(function(versao) {
          if (!versao) {
            alert("A versão deve ser informada!");
            self.resetData();
            return;
          }

          self.msg = "Seu upload começou";
          self.uploading = true;
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;
          let data = new FormData();
          let file = event.target.files[0];

          self.filename = {
            name: file.name,
            size: (file.size / 1024 / 1024).toFixed(2) + " MB"
          };
          data.append("file", file);
          Arquivos.uploadArquivo(data, versao)
            .then(r => {
              self.msg = "Upload Concluido!";
              self.resetData();
            })
            .catch(() => {
              self.msg = "O servidor rejeitou este arquivo.";
              self.resetData();
            });
        })
        .catch(function() {
          alert("A versão deve ser informada!");
          self.resetData();
        });
    },
    resetData() {
      this.uploading = false;
      this.progress = 0;
      this.filename = "";
      //this.msg = false;
      this.socketsA = false;
      this.uploading = false;
      const input = this.$refs.fileInput;
      input.type = "text";
      input.type = "file";
    }
  }
};
</script>

<style lang="scss">
.upandamento {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20vw !important;
  justify-content: space-around;
}
.dropbox {
  outline: 2px dashed white;
  outline-offset: -10px;
  background: #366273;
  color: white;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -webkit-transition: all 0.25s ease;
}
.dropuploading {
  outline: 2px dashed white;
  outline-offset: -10px;
  background: #585858;
  color: white;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  position: relative;
  cursor: default;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #86c359;
  transition: all 0.8ms; /* when mouse over to the drop zone, change color */
}
.dropbox:hover p {
  font-size: 1.7em;
}
.dropbox p {
  font-size: 1.5em;
  text-align: center;
  font-weight: 500;
  transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -webkit-transition: all 0.25s ease;
}

.dropuploading p {
  font-size: 1.5em;
  text-align: center;
  font-weight: 500;
  transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -webkit-transition: all 0.25s ease;
}
</style>